import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { ConvertToSharesSummaryDto } from '../../types/safes.types';
import { useAppMutation } from '../use-app-mutation.hook';
import { SafeConversionSummaryResponse } from './use-safe-conversion-summary';

export type SafeConversionSummaryBulkItem = {
  safeId: string;
  summary: SafeConversionSummaryResponse;
};

export const useSafeConversionSummaryBulk = () => {
  const { mutate: getBulkSummary, isPending } = useAppMutation<
    SafeConversionSummaryBulkItem[],
    Error,
    { companyId: string; data: ConvertToSharesSummaryDto }
  >([QueryKey.GET_SAFE_CONVERSION_SUMMARY], {
    // The summary shows a refused selection inline; a toast per refused request stacked up as the
    // user toggled SAFEs in and out of a group that stayed over 100 %.
    defaultErrorHandling: false,
    mutationFn: ({ companyId, data }: { companyId: string; data: ConvertToSharesSummaryDto }) =>
      ApiService.post<SafeConversionSummaryBulkItem[]>(
        {
          endpoint: BackendRoute.COMPANIES,
          routePath: [companyId, 'safes', 'convert-summary-bulk'],
        },
        { body: data },
      ),
  });

  return { getBulkSummary, isPending };
};
